/**
 * Componente de estado para mostrar mensajes cuando no hay resultados de búsqueda
 * 
 * @description Proporciona feedback visual claro al usuario en dos escenarios:
 * estado inicial (sin búsqueda) y estado sin resultados (búsqueda sin coincidencias).
 * Implementa accesibilidad completa con ARIA live regions para anunciar cambios
 * de estado a lectores de pantalla de manera no intrusiva.
 * 
 * **Estados manejados:**
 * - **Estado inicial**: Query vacío - solicita al usuario escribir
 * - **Sin resultados**: Query con contenido - sugiere intentar otras palabras
 * 
 * @component
 * @param {Object} props - Propiedades del componente
 * @param {string} [props.query=''] - Texto de búsqueda ingresado por el usuario
 * 
 * @returns {JSX.Element} Mensaje de estado con icono y texto apropiado
 * 
 * @since 1.0.0
 * @author Valeria Garcia
 * 
 * @see {@link ../results/results.js} Componente que utiliza WithoutResults
 * @see {@link ../BuscadorApp.js} Aplicación principal que maneja estados
 * @see {@link https://www.w3.org/WAI/ARIA/apg/patterns/alert/} Guía ARIA para mensajes de estado
 */
import './withoutResults.sass';
import withoutResultsIMG from '../../assets/no_search.svg';


export default function WithoutResults({ query = '' }) {
  const message = query.trim().length === 0
    ? 'Escribe un tema o pregunta y deja que nuestro asistente te muestre lo más relevante.'
    : <>No encontramos resultados relevantes para esta búsqueda.<br />¿Quieres intentar con otras palabras?</>;

  return (
    <section className='list-wrapper-results' style={{ maxHeight: '500px', overflow: 'hidden' }}>
      <div id="resultados" className='grid-news grid-alert' role="region" aria-label="Resultados de búsqueda">
        <div className="sin-resultados grid-news" role="status" aria-live="polite">

          {query.trim().length !== 0 && <img src={withoutResultsIMG} alt='without-results' className='sin-resultados-img' />}

          <span className="text-sin-resultados">{message}</span>
        </div>
      </div >
    </section>
  );
}